import { render } from "./Summary.vue?vue&type=template&id=36db9a6f&scoped=true"
import script from "./Summary.vue?vue&type=script&lang=js"
export * from "./Summary.vue?vue&type=script&lang=js"

import "./Summary.vue?vue&type=style&index=0&id=36db9a6f&scoped=true&lang=css"
import "./Summary.vue?vue&type=style&index=1&id=36db9a6f&scoped=true&lang=css"
import "./Summary.vue?vue&type=style&index=2&id=36db9a6f&scoped=true&lang=css"
import "./Summary.vue?vue&type=style&index=3&id=36db9a6f&scoped=true&lang=css"
import "./Summary.vue?vue&type=style&index=4&id=36db9a6f&scoped=true&lang=css"
import "./Summary.vue?vue&type=style&index=5&id=36db9a6f&lang=css"
import "./Summary.vue?vue&type=style&index=6&id=36db9a6f&scoped=true&lang=css"
import "./Summary.vue?vue&type=style&index=7&id=36db9a6f&scoped=true&lang=css"

import exportComponent from "/home/runner/work/adx-front-end/adx-front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36db9a6f"]])

export default __exports__